module.exports = __webpack_public_path__ + "img/article2.a377d14c.png";